module.exports = __webpack_public_path__ + "images/f0fd8ab0d3b5ebe78073172315d0781c.png";